import { ref, push, set } from 'firebase/database';
import { database } from '../firebaseConfig';
import { OUTREACH_KINDS, periodStarts, tallyOutreach } from '../shared/performanceMath';

// "My Outreach": one small entry per personal call, text, email or appointment, saved under
// users/{uid}/outreach/{id} = { kind, at, source, contactId?, contactName?, apptType?, apptAt?, manual? }.
// Only actions a person takes are recorded. Campaign, bulk, reminder and other automatic sends never call this.
export { OUTREACH_KINDS, periodStarts, tallyOutreach };
export const APPT_TYPES = ['Listing appointment', 'Buyer consult', 'Showing', 'Other'];

const clean = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== ''));

export const recordOutreach = async (uid, kind, source, extra = {}) => {
  if (!uid || !OUTREACH_KINDS.some((k) => k.key === kind)) return;
  try {
    await set(push(ref(database, `users/${uid}/outreach`)), clean({ kind, source, at: new Date().toISOString(), ...extra }));
  } catch (e) { console.error('Could not record outreach', e); }
};

// Contact timeline entry -> outreach kind. Bulk sends and reminders/automatic entries are not personal outreach.
export const outreachKindForActivity = (entry = {}) => {
  if (entry.bulk || entry.automatic || entry.system) return null;
  if (entry.type === 'call' || entry.type === 'call_attempt') return 'call';
  if (entry.type === 'text' || entry.type === 'email' || entry.type === 'appointment') return entry.type;
  return null;
};

// periodStarts and tallyOutreach live in src/shared/performanceMath.js (also used by the MCP server).
